import { Box, CircularProgress, Button } from "@mui/material"
import { useState } from 'react';
import {notifyReportDownloadSucess} from "./notifications"
import {downloadReport} from "../services/CatalogsService"


const TableContentReport = () => {
    const [savingIsLoading] = useState(false)
    const token = localStorage.getItem("site")
    let date = new Date();

    const [month, day, year] = [
        date.getMonth(),
        date.getDate(),
        date.getFullYear(),
      ];
    
    const downloadReportAction = async () => {
        try {
            const response = await downloadReport(token)
            if (response.status === 200) {
                const blob = new Blob([response.data]);
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", `Report-${year}-${month}-${day}.csv`);
                document.body.appendChild(link);
                link.click();
                window.URL.revokeObjectURL(url);
                notifyReportDownloadSucess("Report download successfully")
            }
        } catch (err) {
        }
    }

    const downloadReportHandle = () => {
        downloadReportAction()
    }

   return (
       <Box component="section" sx={{ margin: 5, justifyContent: "center", display:"flex"}}>
           <Box component="div" sx={{ textAlign: "center"}}>
            <Box component="p">Download report (Model List vs Temp tables)</Box> 
            <Button onClick={()=> downloadReportHandle()} variant="contained" style={{marginLeft: 10}}>
                {savingIsLoading ? <CircularProgress size={24} /> : "Download"}
            </Button>
           </Box>

       </Box>
   )
}

export default TableContentReport